
const ChairmanSection = () => {
  
  return (
    <section className="ftco-section ftco-no-pt ftco-no-pb"> 
      <div className="container">

      <div className="row justify-content-center mt-3 pb-4">
          <div className="col-md-12  heading-section ftco-animate text px-4">
            <h2 className="mb-4 text-success text-center">
              <span className="text-warning">Management </span> Team
            </h2>   
          </div>
        </div>
          
        <div className="row mt-3">
          <div className=" col-md-12 order-md-first ">
            <div className="text px-4">
              <h2 className="mb-4 text-primary"> Chairman’s Message </h2>
              <p>Welcome to Kaamadhenu College of Education.</p>
              <p>Kaamadhenu College of Education was established with the aim of contributing to the field
of teacher education by preparing competent, committed, and socially responsible teachers.
Education is a powerful force in shaping individuals and society, and teachers play a crucial
role in this transformative process. </p>
<p>At our institution, we focus on providing sound academic training, strong pedagogical
foundations, and value oriented education to prospective teachers. We strive to create a
supportive learning environment where student teachers can develop professionally and
personally, in accordance with the norms and regulations prescribed by the statutory
authorities. </p>
<p>The college is committed to offering necessary academic facilities, practical exposure, and
student support services that enable meaningful learning experiences. Our dedicated faculty
and staff work continuously to guide students towards responsible teaching practices and
lifelong professional growth. </p>
<p>I invite you to explore our academic programmes, campus facilities, and institutional
initiatives. I wish all our students a purposeful learning journey and encourage them to
contribute positively to the field of education and to society.
              </p>
              <h5 className='font-weight-bold text-left'>With best wishes, <br/>Shri. R. Perumalsamy <br/>Chairman</h5>
             </div>
          </div>
        </div>  
      </div>
      <hr className="custom-hr"/>
    </section>
  );
};

export default ChairmanSection;
